import i18nFactory from '@yandex-int/i18n';
import classNames from 'classnames';
import { Icon } from 'lego-on-react';
import * as React from 'react';

import { Bem } from '../../service/Bem/Bem';
import { TurbolandingPage } from '../../typings/banners';
import { ButtonDecorator } from '../ButtonDecorator/ButtonDecorator';
import { InputField, InputFieldType } from '../InputField/InputField';
import { Shape2, Shape2Icon, Shape2Theme } from '../Shape2/Shape2';

import './TurbolandingCompact.css';
import * as keyset from './TurbolandingCompact.i18n';

const i18n = i18nFactory(keyset);

const BLOCK = 'turbo-landing-compact';

export interface TurbolandingCompactProps {
    turbolanding?: TurbolandingPage;
    isReadonly?: boolean;
    isLoading?: boolean;
    cls?: string;
    isMassActionsDifferentValues?: boolean;

    onOpenCanvas: () => void;
    onDeleteTurbo: () => void;
}

export class TurbolandingCompact extends React.Component<
    TurbolandingCompactProps
> {
    render() {
        const { turbolanding, isMassActionsDifferentValues } = this.props;

        return turbolanding || isMassActionsDifferentValues
            ? this.buildTurbolandingView()
            : this.buildEmptyView();
    }

    private buildEmptyView() {
        return (
            <ButtonDecorator
                text={i18n('add-turbo')}
                theme={'pseudo'}
                size={'n'}
                width={'max'}
                onClick={this.props.onOpenCanvas}
                iconLeft={<Icon cls={Bem.cls(BLOCK, 'button-icon-add')} />}
            />
        );
    }

    private buildTurbolandingView() {
        const {
            turbolanding,
            cls,
            isReadonly,
            isLoading,
            isMassActionsDifferentValues
        } = this.props;
        let name;
        const isShowDifferentValues =
            !turbolanding && isMassActionsDifferentValues;
        if (isShowDifferentValues) {
            name = i18n('different-turbo');
        } else {
            name = turbolanding ? turbolanding.name : undefined;
        }
        const replaceHintText = isShowDifferentValues
            ? i18n('edit-all')
            : i18n('edit');

        return (
            <div className={classNames(Bem.cls(BLOCK), cls)}>
                <span className={Bem.cls(BLOCK, 'turbo-title')}>
                    {i18n('turbo')}
                </span>
                <div className={Bem.cls(BLOCK, 'turbo-body')}>
                    <div className={Bem.cls(BLOCK, 'name')}>
                        <InputField
                            size={'n'}
                            theme={'normal'}
                            inputType={InputFieldType.TEXT}
                            disabled={true}
                            onChange={this.onChangeInput}
                            text={name}
                        />
                    </div>
                    <ButtonDecorator
                        cls={Bem.cls(BLOCK, 'delete')}
                        theme="pseudo"
                        view="default"
                        tone="default"
                        size="n"
                        disabled={isReadonly || isLoading}
                        onClick={this.onDeleteTurbo}
                    >
                        <Shape2
                            cls={Bem.cls(BLOCK, 'trash-icon')}
                            height={16}
                            width={16}
                            theme={Shape2Theme.default}
                            icon={Shape2Icon.trashbin}
                        />
                    </ButtonDecorator>
                    <ButtonDecorator
                        cls={Bem.cls(BLOCK, 'edit')}
                        theme={isLoading ? 'action' : 'pseudo'}
                        progress={isLoading}
                        view="default"
                        tone="default"
                        size="n"
                        disabled={isReadonly || isLoading}
                        onClick={this.props.onOpenCanvas}
                    >
                        {replaceHintText}
                    </ButtonDecorator>
                </div>
            </div>
        );
    }

    private onDeleteTurbo = () => {
        return this.props.onDeleteTurbo();
    };

    private onChangeInput = () => {
        // заглушка
    };
}
